module.exports = "/assets/hero-main.webp"